import isEmpty from "src/shared/util/is-empty";
import { Variant } from "../model/Variant";
import isColorVariant from "./is-color-variant";
import isSizeVariant from "./is-size-variant";

enum VariantAttributeType {
  Color = "Color",
  Size = "Size",
}
export interface EnabledVariants {
  Color?: boolean;
  Size?: boolean;
}

const getEnabledVariants = (variants: Variant[]): EnabledVariants => {
  const attributeKeys: string[] = Array.isArray(variants)
    ? variants.map((v: Variant) => v.attributeKey)
    : [];

  const hasColorAttribute = !isEmpty(
    attributeKeys.filter((attrKey) => isColorVariant(attrKey))
  );
  const hasSizeAttribute = !isEmpty(
    attributeKeys.filter((attrKey) => isSizeVariant(attrKey))
  );

  const enabledVariants: EnabledVariants = {};

  if (hasColorAttribute) {
    enabledVariants[VariantAttributeType.Color] = true;
  }
  if (hasSizeAttribute) {
    enabledVariants[VariantAttributeType.Size] = true;
  }

  return enabledVariants;
};

export default getEnabledVariants;
